module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "message",
    class: _vm.messageClass
  }, [_c('div', {
    staticClass: "body",
    domProps: {
      "innerHTML": _vm._s(_vm.formattedBody)
    }
  }), (_vm.message.status === 'sending') ? _c('small', [_vm._v("sending")]) : _vm._e(), (_vm.message.status === 'error') ? _c('small', {
    staticClass: "error",
    on: {
      "click": _vm.resend
    }
  }, [_vm._v("try again")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f4a2a7c4","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Message.vue
// module id = 127
// module chunks = 1